/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Code_PlaceholderInputs */

const en_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const de_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const pt_br2_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const tr_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const zh_cn2_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const zh_hk2_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const ko_kr2_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const ru_ru2_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const es_419_login_page_code_placeholder = /** @type {(inputs: Login_Page_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

/**
* | output |
* | --- |
* | "000000" |
*
* @param {Login_Page_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_code_placeholder = /** @type {((inputs?: Login_Page_Code_PlaceholderInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Code_PlaceholderInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_code_placeholder(inputs)
	if (locale === "de") return de_login_page_code_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_code_placeholder(inputs)
	if (locale === "tr") return tr_login_page_code_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_code_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_code_placeholder(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_code_placeholder(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_code_placeholder(inputs)
	return es_419_login_page_code_placeholder(inputs)
});